function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { debugLog } from '../../debugLog';
export class CHELCarnelianSmcnPlayer {
    // エラー回避のためとりあえずメソッドを追加
    setData(data) {
        debugLog('[ setData ] CHELCarnelianSmcnPlayer: Method not implemented.');
    }
    getName() {
        debugLog('[ getName ] CHELCarnelianSmcnPlayer: Method not implemented.');
        return '';
    }
    getParam(key) {
        debugLog('[ getParam ] CHELCarnelianSmcnPlayer: Method not implemented.');
        return '';
    }
    SetScreenShare(use) {
        debugLog('[ SetScreenShare ] CHELCarnelianSmcnPlayer: Method not implemented.');
    }
    IsScreenShare() {
        debugLog('[ IsScreenShare ] CHELCarnelianSmcnPlayer: Method not implemented.');
        return false;
    }
    release() {
        debugLog('[ release ] CHELCarnelianSmcnPlayer: Method not implemented.');
    }
    getPeerId() {
        return this.playerId;
    }
    getPlayerId() {
        return this.playerId;
    }
    setStream(stream) {}
    setChannelSessionCode(channelSessionCode) {
        this.channelSessionCode = channelSessionCode;
    }
    getChannelSessionCode() {
        return this.channelSessionCode;
    }
    getValue(key) {
        // @ts-ignore
        return this[key];
    }
    getVideoMediaStream() {
        const mediaStream = new MediaStream();
        return mediaStream;
    }
    setVolume(volume) {
        this.volume = volume;
        this.updateVolume();
    }
    SetVoiceAttenuate(volume) {
        this.attenuateVolume = volume;
    // サーバサイド距離減衰をするのでコメントアウト
    // this.updateVolume();
    }
    SetMute(mute) {
        this.mute = mute;
        this.updateVolume();
    }
    updateVolume() {}
    setFullAvatarState(isFullAvatar) {
        this.isFullAvatar = isFullAvatar;
    }
    setMotionTrackingState(isMotionTracking) {
        this.isMotionTracking = isMotionTracking;
    }
    isHighFrequentSync() {
        if (this.role === 'presenter') {
            return true;
        }
        if (this.isFullAvatar && this.isMotionTracking) {
            return true;
        }
        return false;
    }
    constructor(playerId, userCode, volume, role, rtcUserCode){
        _defineProperty(this, "playerId", void 0);
        _defineProperty(this, "context", void 0);
        _defineProperty(this, "gainNode", void 0);
        _defineProperty(this, "volume", void 0);
        _defineProperty(this, "attenuateVolume", void 0);
        _defineProperty(this, "mute", void 0);
        _defineProperty(this, "source", void 0);
        _defineProperty(this, "audioDestination", void 0);
        _defineProperty(this, "audio", void 0);
        _defineProperty(this, "role", void 0);
        _defineProperty(this, "rtcUserCode", void 0);
        _defineProperty(this, "channelSessionCode", void 0);
        _defineProperty(this, "isFullAvatar", void 0);
        _defineProperty(this, "isMotionTracking", void 0);
        console.log(playerId, userCode, volume, role);
        this.playerId = playerId;
        this.role = role;
        this.audio = document.createElement('audio');
        this.volume = volume;
        this.attenuateVolume = 0.0;
        this.mute = false;
        this.channelSessionCode = '';
        this.rtcUserCode = rtcUserCode;
        this.updateVolume();
        this.isFullAvatar = true;
        this.isMotionTracking = false;
    }
}
